import { render, staticRenderFns } from "./jspLogin.vue?vue&type=template&id=1662957d&scoped=true&"
import script from "./jspLogin.vue?vue&type=script&lang=js&"
export * from "./jspLogin.vue?vue&type=script&lang=js&"
import style0 from "./jspLogin.vue?vue&type=style&index=0&id=1662957d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1662957d",
  null
  
)

export default component.exports